import React from "react";
import {registerBlockType} from "@wordpress/blocks";
import { Fragment } from "@wordpress/element";
import PMGColorPalette,{fontColorAssociations} from "./PMGColorPalette";

import {RichText} from "@wordpress/block-editor";
import {PanelBody,Panel,RangeControl,SelectControl,TextControl,CheckboxControl,Button} from "@wordpress/components";
import {
    useBlockProps,
    ColorPalette,
    InspectorControls,
    InnerBlocks,
    BlockControls,
    AlignmentToolbar,
    __experimentalLinkControl as LinkControl,
    MediaUpload,
    MediaUploadCheck
} from '@wordpress/block-editor';

registerBlockType({
  "name":"template-scripts/hero",
  "title":"Hero Section",
  "category":"template-scripts",
  "icon":"button",
  attributes:{
    mainText:{type:'string'},
    subText:{type:'string'},
    link:{type:'object'},
    buttonText:{type:'string'},
    videoMedia:{type:'object'},
    buttonColor:{type:'string',default:'#b65943'},
    buttonFontColor:{type:'string',default:'#fff'},
    arrowIcon:{type:'boolean',default:false},
    showButton:{type:'boolean',default:true}
  }
},{
  edit:function({attributes,setAttributes}){
    const showMedia = false;
    return (<>
    <InspectorControls>
    <Panel>
    {showMedia ? (<PanelBody title="Photo/Video" initialOpen={true}>
          <MediaUploadCheck>
            <MediaUpload
              onSelect={(m)=>{
                console.log({m});
                setAttributes({videoMedia:m});
              
              }}
              value={attributes.videoMedia?.id}
              allowedTypes={['mp4','video','jpg','image','png','gif','webp']}
              render={({open})=>(
                <Button
                  className={attributes.videoMedia?.id == 0 ? 'editor-post-featured-image__toggle' : 'editor-post-featured-image__preview'}
                  onClick={open}
                  style={{flexDirection:"column"}}
                >
                  {attributes.videoMedia?.type == "video" ? (<video src={attributes.videoMedia?.url} muted={`muted`} autoplay={`autoplay`} loop/>) : (<></>)}
                  {attributes.videoMedia?.type == "image" ? (<img src={attributes.videoMedia?.url}/>) : (<></>)}
                  <span style={{display:"block",padding:"10px"}}>Select Photo or Video</span>
                </Button>
              )}

            />
          </MediaUploadCheck>
          {attributes.videoMedia?.id ? (<div  style={{display:"block",textAlign:"center"}}><Button isDestructive={true} onClick={()=>setAttributes({videoMedia:false})}>Remove Photo/Video</Button></div>) : (<></>)}

      </PanelBody>) : (<></>)}
      <PanelBody title="Button">
          <CheckboxControl
            label="Show Button"
            checked={attributes.showButton}
            onChange={(v)=>setAttributes({showButton:v})}
          />
      </PanelBody>
      <PanelBody title="Button Link">
        <LinkControl placeholder="Button Link" onChange={(v)=>{ console.log(v); setAttributes({link:v}); }} value={attributes.link}/>
      </PanelBody>
      {attributes.showButton ? (<>
        <PanelBody title="Button Color">
          
          <PMGColorPalette
            value={attributes.buttonColor}
            onChange={(v)=>{
              var fontColor = fontColorAssociations[v] || "#ffffff";
              setAttributes({
                buttonFontColor:fontColor,
                buttonColor:v
              });
            }}
          />
        </PanelBody>
        <PanelBody title="Button Icon">
            <CheckboxControl
              label="Show Forward Arrow Icon"
              checked={attributes.arrowIcon}
              onChange={(v)=>setAttributes({arrowIcon:v})}
            />
        </PanelBody>
      </>) : (<></>)}
    </Panel>
    </InspectorControls>
      <div className="hero">
        
        <div className="content">
            <div className="text"> 
              <h1>
                <RichText tagName="b" placeholder="Main Text Goes Here" onChange={(v)=>setAttributes({mainText:v})} value={attributes.mainText}/>
                <RichText tagName="span" placeholder="Main Text Goes Here" onChange={(v)=>setAttributes({subText:v})} value={attributes.subText}/>
              </h1>
              {attributes.showButton ? (<a onClick={(e)=>e.preventDefault()} href={attributes.link?.url} className={`btn large`} style={{color:attributes.buttonFontColor,backgroundColor:attributes.buttonColor,background:attributes.buttonColor}}>
                <RichText tagName="div" placeholder="Button Text" value={attributes.buttonText} onChange={(v)=>setAttributes({buttonText:v})}/>
                {attributes.arrowIcon ? (
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="48" d="M268 112l144 144-144 144M392 256H100"/></svg>
                ) : (<></>)}
              </a>) : (<></>)}

            </div>
            {attributes.videoMedia?.id ? (<div className="video">
            {(attributes.videoMedia.type == "video") ? 
              (<video autoplay="autoplay" muted="muted" src={attributes.videoMedia?.url} loop></video>) : 
              (<>
                {(attributes.videoMedia.type == "image") ? (<img src={attributes.videoMedia?.url}/>) : (<></>)}
              </>)
            }
            </div>) : (<></>)}

        </div>
      </div>
    </>);
  },
  save:function({attributes}){
    return (<div className="hero"> 
      <div className="content">
          <div className="text"> 
            <h1>
              <RichText.Content tagName="b" value={attributes.mainText}/>
              <RichText.Content tagName="span" value={attributes.subText}/>
            </h1>
              
            {attributes.showButton ? (<a href={attributes.link?.url} className={`btn large`} style={{color:attributes.buttonFontColor,backgroundColor:attributes.buttonColor,background:attributes.buttonColor}}>
              <RichText.Content tagName="div" value={attributes.buttonText}/>
              {attributes.arrowIcon ? (
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="48" d="M268 112l144 144-144 144M392 256H100"/></svg>
              ) : (<></>)}
            </a>) : (<></>)}
          </div>

          {attributes.videoMedia?.id ? (<div className="video">
            {(attributes.videoMedia.type == "video") ? 
              (<video autoplay="autoplay" muted="muted" src={attributes.videoMedia?.url} loop></video>) : 
              (<>
                {(attributes.videoMedia.type == "image") ? (<img src={attributes.videoMedia?.url}/>) : (<></>)}
              </>)
            }
            </div>) : (<></>)}
      </div>
    </div>);
  }
});
